import { AutogenModelZones, AutogenRowZones } from "./autogen/AutogenModelZones";

export class ModelZones extends AutogenModelZones<RowZones> {
    constructor() {
        super(RowZones);
    }
}

export class RowZones extends AutogenRowZones {
}